module.exports = __webpack_public_path__ + "static/media/radeberger-gruppe-x2.8226b721.png";